import { render, staticRenderFns } from "./lawContract.vue?vue&type=template&id=326398e0&scoped=true&"
import script from "./lawContract.vue?vue&type=script&lang=js&"
export * from "./lawContract.vue?vue&type=script&lang=js&"
import style0 from "./lawContract.vue?vue&type=style&index=0&id=326398e0&prod&lang=css&"
import style1 from "./lawContract.vue?vue&type=style&index=1&id=326398e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326398e0",
  null
  
)

export default component.exports